export const desktopMenu = () => {
  $('.site-navigation .menu > li > a').click(function () {
    $('.site-navigation .menu > .is-active').removeClass('is-active');
    $(this).closest('li').addClass('is-active');
  });

  //mega menu
  $('.site-navigation .menu > li.menu-item-has-children > a').click(function (
    e,
  ) {
    e.preventDefault();
    $('.mega-menu').addClass('is-active');
    $('body').addClass('menu-shown');
    $('.mega-menu-nav').html('');
    var submenu = $(this).next('.sub-menu').clone();
    $('.mega-menu-nav').html(submenu);
  });

  $('body').on('click', '.mega-menu-nav a[href*="#"]', function (e) {
    $('.mega-menu').removeClass('is-active');
    $('body').removeClass('menu-shown');
  });

  $('body').on('click', '.mega-menu-close', function (e) {
    e.preventDefault();
    alert('clicked');
    $('.mega-menu').removeClass('is-active');
    $('body').removeClass('menu-shown');
  });
};
